module.exports = __webpack_public_path__ + "static/media/addIcon.301b9179.png";